import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/common/iosPwa.jpg'


const _hoisted_1 = { class: "pwa-update-install" }
const _hoisted_2 = { class: "header" }




export default /*@__PURE__*/_defineComponent({
  __name: 'iosInstruction',
  emits: ['close-instructions'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const closeInstructions = () => {
    emit('close-instructions');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", { class: "install-header" }, [
        _createElementVNode("span", {
          class: "close-btn",
          onClick: closeInstructions
        }, "✖")
      ]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('pwaInstructions.popupTitle')), 1),
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        style: {"width":"280px","height":"290px"}
      }, null, -1))
    ])
  ]))
}
}

})